import { render, staticRenderFns } from "./ActivateAccountForEvent.vue?vue&type=template&id=35c52338&"
import script from "./ActivateAccountForEvent.vue?vue&type=script&lang=js&"
export * from "./ActivateAccountForEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports